import i18next from "i18next"

/** Translate stored image type codes (URL / UPLOAD) for detail screens. */
export const formatImageTypeLabel = imageType => {
  if (imageType == null || imageType === "") return "-"
  const normalized = String(imageType).trim().toUpperCase()
  if (normalized === "URL") return i18next.t("Image Url")
  if (normalized === "UPLOAD") return i18next.t("Upload Image")
  return i18next.t(String(imageType), { defaultValue: String(imageType) })
}

/** Translate weight unit codes (g, kg, …). */
export const formatWeightUnitLabel = unit => {
  if (unit == null || unit === "") return ""
  return i18next.t(String(unit), { defaultValue: String(unit) })
}

export const formatNetWeightLabel = netWeight => {
  if (!netWeight?.value && netWeight?.value !== 0) return "-"
  const unit = formatWeightUnitLabel(netWeight.unit)
  return unit ? `${netWeight.value} ${unit}` : String(netWeight.value)
}

const ENV_SUFFIX_RE = /^(.*?)([-_.])?(development|staging|production)$/i

/**
 * Translate app-version environment suffixes, e.g. `1.0.0-staging` → `1.0.0-تجريبي`.
 */
export const formatAppVersionLabel = version => {
  if (version == null || version === "") return ""
  const raw = String(version).trim()
  const match = raw.match(ENV_SUFFIX_RE)
  if (!match) return raw
  const prefix = match[1] || ""
  const sep = match[2] || ""
  const envKey = String(match[3]).toLowerCase()
  const envLabel = i18next.t(envKey, { defaultValue: match[3] })
  if (!prefix) return envLabel
  return `${prefix}${sep}${envLabel}`
}
